import classnames from 'classnames';
import CircularProgress from 'components/CircularProgress';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import EmptyData from 'components/common/EmptyData';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE } from 'components/common/Input/types';
import React, { useMemo } from 'react';
import { LocationRole } from 'types/location';

import { ILeftColumn } from '../../types';

const LeftColumn: React.FC<ILeftColumn> = ({
  title,
  data,
  dataMapper,
  onChange,
  onDelete,
  values,
  hidden,
  isMobile,
  onTitleButtonClick,
  loading,
}) => {
  const hideColumnClass = classnames(
    'h-100 left-column-form transition-all duration-150 border-border_color flex-1 p-4 overflow-y-auto',
    {
      'border-r': !isMobile,
      'w-full': isMobile,
      '-translate-x-full absolute': isMobile && hidden,
    },
  );

  const LeftColumnComponent = useMemo(
    () =>
      data?.map((d) => {
        const { component, className: dataRowClassName, disableRow } = dataMapper?.(d) || {};
        return (
          <div
            className={`p-3 flex first:border-t border-b border-l border-r left-column-row border-border_color items-center ${
              dataRowClassName || ''
            }`}
            key={d.id}>
            {component && <div className='flex-1'>{component}</div>}
            <div className='ml-2 flex items-center'>
              <InputComponent
                style={{ marginBottom: 0, minWidth: 103 }}
                type={INPUT_TYPE.SELECT}
                name={d.id}
                value={values?.[d.id]}
                disabled={disableRow}
                onChange={(v: LocationRole) => {
                  if (!disableRow) onChange?.(v, d);
                }}
                inputOptions={[
                  {
                    label: 'Employee',
                    value: LocationRole.EMPLOYEE,
                  },
                  {
                    label: 'Admin',
                    value: LocationRole.LOCATION_ADMIN,
                  },
                ]}
              />
              <div className='ml-2'>
                <ButtonWithSpinner
                  width='auto'
                  style={{ padding: '0 5px' }}
                  buttonType='text'
                  onClick={() => {
                    if (!disableRow) onDelete?.(d);
                  }}>
                  <span className='text-lg'>x</span>
                </ButtonWithSpinner>
              </div>
            </div>
          </div>
        );
      }),
    [data, dataMapper, onChange, onDelete],
  );

  return (
    <div className={hideColumnClass}>
      <div className='flex mb-4 '>
        <div className='flex-1 p-1 text-lg'>{title}</div>
        {isMobile && (
          <div>
            <ButtonWithSpinner
              width='auto'
              height='auto'
              bgColor='transparent'
              color='#038fde'
              onClick={onTitleButtonClick}>
              <span className=''>+ Add</span>
            </ButtonWithSpinner>
          </div>
        )}
      </div>
      <div className='overflow-y-auto overflow-x-hidden'>
        {LeftColumnComponent}
        {loading && <CircularProgress />}
        {!data?.length && !loading && <EmptyData />}
      </div>
    </div>
  );
};

export default React.memo(LeftColumn);
